import { Autocomplete, Box, Button, Chip, IconButton, InputAdornment, ListItem, ListItemText, Stack, TextField, Tooltip, Typography } from '@mui/material';
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import '../../../FrontOffice/IPPatients/PatientsDetails/ClinicalNotes/DoctorNotes.css'
import { DeletePopup } from '../../../../Components/Common Components/CommonComponents';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { Colors } from '../../../../Styles/Colors';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import AddIcon from '@mui/icons-material/Add';
import { defaultRouteList } from '../../../../Utility/Constants';
import DeleteIcon from '@mui/icons-material/Delete';
class DocPlanRight extends Component {
  constructor(props) {
    super(props)
    this.state = {
      Comments: "",
      InhouseTreatment: "",
      NewInhouseTreatment: "",
      NewInhouseTreatmentAdd: false,
      InhouseTreatmentList: [],
      Route: "",
      NewRoute: "",
      NewRouteAdd: false,
      RouteList: JSON.parse(JSON.stringify(defaultRouteList)),
      Procedure: "",
      NewProcedure: "",
      NewProcedureAdd: false,
      ProcedureList: [],
      DosageStrength: "",
      Description: "",
      SelectedId: null,
      EditPlanDatas: {},
      clinicID: this.props?.clinicID ? this.props?.clinicID : null,
    }
  }

  componentDidMount() {
    if (this.props.EditPlanDatas && Object.keys(this.props.EditPlanDatas).length !== 0) {
      this.getPlanFrequentList(true, this.props.EditPlanDatas)
      this.props.ClearPropsData()
    } else {
      this.getPlanFrequentList()
    }
  }
  componentDidUpdate(PrevProps) {
    if (PrevProps?.EditPlanDatas !== this.props.EditPlanDatas && this.props.EditPlanDatas && Object.keys(this.props.EditPlanDatas).length !== 0) {
      let states = this.state
      let propData = this.props.EditPlanDatas
      states.InhouseTreatment = propData?.treatment_name
      states.DosageStrength = propData?.dosage
      states.Route = propData?.route
      states.Comments = propData?.comments
      states.Procedure = propData?.procedure_name
      states.Description = propData?.description
      states.EditPlanDatas = this.props.EditPlanDatas
      let ishaveTreatment = this.state.InhouseTreatmentList.some((list) => (list === this.state.InhouseTreatment))
      if (!ishaveTreatment) {
        let List = this.state.InhouseTreatmentList
        List.push(this.state.InhouseTreatment)
        states.InhouseTreatmentList = List
      }
      let isRoute = this.state.RouteList.some((list) => (list?.value === this.state.Route))
      if (!isRoute && this.state.Route) {
        let List = this.state.RouteList
        List.push({ label: this.state.Route, value: this.state.Route })
        states.RouteList = List
      }
      let isHaveProcedure = this.state.ProcedureList.some((list) => (list === this.state.Procedure))
      if (!isHaveProcedure && this.state.Procedure) {
        let List = this.state.ProcedureList
        List.push(this.state.Procedure)
        states.ProcedureList = List
      }
      this.setState({ states })
      this.props.ClearPropsData()
    }
  }

  getPlanFrequentList = (forEdit = false, PropData = {}, newProcedure = "") => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_PLAN_FREQ + `?search_key=${newProcedure}&clinic_id=${this.state.clinicID}`)
      // RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_PLAN_FREQ)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              InhouseTreatmentList: response.data.data?.inhouse_treatments ? response.data.data?.inhouse_treatments : [],
              ProcedureList:  response.data.data?.procedures ? response.data.data?.procedures : [],
            }, () => {
              if (forEdit) {
                let states = this.state
                let ishaveTreatment = this.state.InhouseTreatmentList.some((list) => (list === PropData?.name))
                if (!ishaveTreatment) {
                  let List = this.state.InhouseTreatmentList
                  List.push(PropData?.name)
                  states.InhouseTreatmentList = List
                }
                let isRoute = this.state.RouteList.some((list) => (list?.value === PropData?.route))
                if (!isRoute) {
                  let List = this.state.RouteList
                  List.push({ label: PropData?.route, value: PropData?.route })
                  states.RouteList = List
                }
                let isHaveProcedure = this.state.ProcedureList.some((list) => (list === PropData?.procedure_name))
                if (!isHaveProcedure) {
                  let List = this.state.ProcedureList
                  List.push(PropData?.procedure_name)
                  states.ProcedureList = List
                }
                this.setState({ states })
              }
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  ClearData() {
    this.setState({
      Comments: "",
      InhouseTreatment: "",
      NewInhouseTreatment: "",
      NewInhouseTreatmentAdd: false,
      Route: "",
      NewRoute: "",
      NewRouteAdd: false,
      RouteList: defaultRouteList,
      Procedure: "",
      NewProcedure: "",
      NewProcedureAdd: false,
      DosageStrength: "",
      Description: "",
      SelectedId: null,
      EditPlanDatas: {}
    })
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message,
      deletePopup: false,
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  DeleteAllergy() {
    try {
      var states = this.state
      RestAPIService.delete(Serviceurls.DOC_DOCTOR_NOTES_ALLERGY_FEQ + "?allergy=" + states.SelectedAllergy).
        then((response) => {
          if (response.data.status === "success") {
            this.ClearData()
            this.getPlanFrequentList()
          } else {
            this.errorMessage(response.data.message)
          }
        }).catch(error => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  PostPlanData() {
    try {
      var states = this.state
        let data = {
          "patient_id": this.props?.PatientData?.patient_id,
          "appointment_id": this.props?.PatientData?.appointment_id,
          "treatment_name": states?.InhouseTreatment,
          "dosage": states?.DosageStrength,
          "route": states?.Route,
          "comments": states?.Comments,
          "procedure_name": typeof(states?.Procedure) === 'string' ? states?.Procedure : states?.Procedure?.value,
          "description": states?.Description,
          "type": states?.Procedure?.type

        }
        if( Object.keys(this.state.EditPlanDatas).length > 0){
          data["treatment_id"] = this.state.EditPlanDatas?.treatment_id ? this.state.EditPlanDatas?.treatment_id : null
          data["procedure_id"] = this.state.EditPlanDatas?.procedure_id ? this.state.EditPlanDatas?.procedure_id : null
        }
        RestAPIService.create(data, Serviceurls.DOC_DOCTOR_NOTES_PLAN_POST).
          then((response) => {
            if (response.data.status === "success") {
              this.successMessage(response.data.message)
              this.ClearData()
              this.getPlanFrequentList()
              this.props.CallgetApi('plan')
            } else {
              this.errorMessage(response.data.message)
            }
          }).catch(error => {
            if (error?.response?.data?.status === "fail") {
              this.errorMessage(error.response.data.message)
            } else {
              this.errorMessage(error.message)
            }
          })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }
  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  postTemplateData = () => {
    try {
      let data = {
        doctor_category: this.state.CategoryAddText
      }
      this.setState({ loading: true })
      RestAPIService.create(data, Serviceurls.DOC_DOCTOR_NOTES_PATIENT_CATEGORY_WISE)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.successMessage(response?.data?.message)
            this.ClearData()
            this.getPatientCategoryList()
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.setState({ loading: false })
            this.errorMessage(error.response.data.message)
          } else {
            this.setState({ loading: false })
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ postLoad: false })
      this.errorMessage(error.message)
    }
  }

  deleteFrequencysugg = () => {
    try {
      this.setState({ removeData: true })

      RestAPIService.delete(this.state.DeleteChipType === "treatement" ? `${Serviceurls.DOC_DOCTOR_NOTES_PLAN_FREQ}?treatement=${this.state.SelectedDeleteChip}` : `${Serviceurls.DOC_DOCTOR_NOTES_PLAN_FREQ}?procedure=${this.state.SelectedDeleteChip}`)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.successMessage(response?.data?.message)
            this.getPlanFrequentList()
            if (this.state.DeleteChipType === "treatement" && this.state.SelectedDeleteChip === this.state.InhouseTreatment) {
              this.setState({ InhouseTreatment: "" })
            }
            if (this.state.DeleteChipType === "procedure" && this.state.SelectedDeleteChip === this.state.Procedure) {
              this.setState({ Procedure: "" })
            }
            this.setState({ deletePopup: false, SelectedDeleteChip: null, removeData: false, DeleteChipType: "" }, () => {

            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.setState({ removeData: false })
            this.errorMessage(error.response.data.message)
          } else {
            this.setState({ removeData: false })
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ removeData: false })
      this.errorMessage(error.message)
    }
  }

  popupClose() {
    this.setState({ deletePopup: false })
  }

  render() {
    const { t } = this.props
    return (
      <Box emed_tid="doc_plan_right_container">
        <Typography className='eMed_refdoc_title' emed_tid="doc_plan_right_title">{this.props.SelectedCompCustomName ? this.props.SelectedCompCustomName : 'Plan'}</Typography>
        <Box height={"56.5vh"} overflow={'auto'} emed_tid="doc_plan_right_content">
          <Box emed_tid="doc_plan_right_treatment_box">
            <Typography className='eMed_refdoc_title' emed_tid="doc_plan_right_treatment_label">{t("Inhouse Treatment")}</Typography>
            <Box className="eMed_DocNotes_FreqChips_Wrapp" emed_tid="doc_plan_right_treatment_chips">
              {
                this.state.InhouseTreatmentList?.length > 0 ? this.state.InhouseTreatmentList.map((item, index) => (
                  <Chip
                    emed_tid={`doc_plan_right_treatment_chip_${index}`}
                    size='small'
                    className={`eMed_chip ${this.state.InhouseTreatment === item ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                    key={index}
                    label={item}
                    variant={this.state.InhouseTreatment === item ? 'contained' : "outlined"}
                    onClick={() => { this.setState({ InhouseTreatment: item }) }}
                    onDelete={() => { this.setState({ deletePopup: true, SelectedDeleteChip: item, DeleteChipType: "treatement" }) }}
                  />
                )) : null
              }
              {this.state.NewInhouseTreatmentAdd ?
                <TextField
                  emed_tid="doc_plan_right_treatment_new_textfield"
                  size='small'
                  value={this.state.NewInhouseTreatment}
                  onChange={(e) => {
                    this.setState({ NewInhouseTreatment: e.target.value })
                  }}
                  inputProps={{ maxLength: 30, style: { height: "0.8vw" }, emed_tid: "doc_plan_right_treatment_new_input" }}
                  sx={{ width: "10vw", marginLeft: "0.5vw", marginTop: '0.3vw' }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && this.state.NewInhouseTreatment !== "") {
                      let List = this.state.InhouseTreatmentList
                      if (!List.includes(this.state.NewInhouseTreatment)) {
                        List.push(this.state.NewInhouseTreatment)
                      }
                      this.setState({
                        InhouseTreatmentList: List,
                        InhouseTreatment: this.state.NewInhouseTreatment,
                        NewInhouseTreatment: "",
                        NewInhouseTreatmentAdd: false
                      })
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" emed_tid="doc_plan_right_treatment_new_adornment">
                        <IconButton
                          disabled={this.state.NewInhouseTreatment === ""}
                          onClick={() => {
                            let List = this.state.InhouseTreatmentList
                            if (!List.includes(this.state.NewInhouseTreatment)) {
                              List.push(this.state.NewInhouseTreatment)
                            }
                            this.setState({
                              InhouseTreatmentList: List,
                              InhouseTreatment: this.state.NewInhouseTreatment,
                              NewInhouseTreatment: "",
                              NewInhouseTreatmentAdd: false
                            })
                          }}
                          emed_tid="doc_plan_right_treatment_new_add_btn">
                          <AddIcon color={this.state.NewInhouseTreatment === "" ? 'grey' : 'primary'} emed_tid="doc_plan_right_treatment_new_add_icon" />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }} /> :
                <IconButton
                  onClick={() => {
                    this.setState({
                      NewInhouseTreatmentAdd: true
                    })
                  }}
                  emed_tid="doc_plan_right_treatment_add_btn">
                  <AddIcon color={'primary'} emed_tid="doc_plan_right_treatment_add_icon" />
                </IconButton>
              }
            </Box>
          </Box>
          <Box emed_tid="doc_plan_right_dosage_box">
            <Typography className='eMed_refdoc_title' emed_tid="doc_plan_right_dosage_label">{t("Dosage Strength")}</Typography>
            <TextField
              emed_tid="doc_plan_right_dosage_textfield"
              size='small'
              className='eMed_DocNotes_TextFields'
              label={t("Dosage Strength")}
              inputProps={{ maxLength: 50, emed_tid: "doc_plan_right_dosage_input" }}
              value={this.state.DosageStrength}
              onChange={(e) => {
                if (CommonValidation.ALPHA_NUM_SPLCHAR(e.target.value) || e.target.value === "") {
                  this.setState({ DosageStrength: e.target.value })
                }
              }}
            />
          </Box>
          <Box emed_tid="doc_plan_right_route_box">
            <Typography className='eMed_refdoc_title' emed_tid="doc_plan_right_route_label">{t("Route")}</Typography>
            <Box className="eMed_DocNotes_FreqChips_Wrapp" emed_tid="doc_plan_right_route_chips">
              {
                this.state.RouteList?.length > 0 ? this.state.RouteList.map((item, index) => (
                  <Chip
                    emed_tid={`doc_plan_right_route_chip_${index}`}
                    size='small'
                    className={`eMed_chip ${this.state.Route === item?.value ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                    key={index}
                    label={item?.value}
                    variant={this.state.Route === item?.value ? 'contained' : "outlined"}
                    onClick={() => { this.setState({ Route: item?.value }) }}
                  />
                )) : null
              }
              {this.state.NewRouteAdd ?
                <TextField
                  emed_tid="doc_plan_right_route_new_textfield"
                  size='small'
                  value={this.state.NewRoute}
                  onChange={(e) => {
                    this.setState({ NewRoute: e.target.value })
                  }}
                  inputProps={{ maxLength: 30, style: { height: "0.8vw" }, emed_tid: "doc_plan_right_route_new_input" }}
                  sx={{ width: "10vw", marginLeft: "0.5vw", marginTop: '0.3vw' }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && this.state.NewRoute !== "") {
                      let List = this.state.RouteList
                      let isHaveItem = List.find((item) => (item?.value?.toLowerCase().trim() === this.state.NewRoute?.toLowerCase().trim()))
                      if (!isHaveItem) {
                        List.push({ value: this.state.NewRoute, label: this.state.NewRoute })
                      }
                      this.setState({
                        RouteList: List,
                        Route: isHaveItem ? isHaveItem?.value : this.state.NewRoute,
                        NewRoute: "",
                        NewRouteAdd: false
                      })
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" emed_tid="doc_plan_right_route_new_adornment">
                        <IconButton
                          disabled={this.state.NewRoute === ""}
                          onClick={() => {
                            let List = this.state.RouteList
                            let isHaveItem = List.find((item) => (item?.value?.toLowerCase().trim() === this.state.NewRoute?.toLowerCase().trim()))
                            if (!isHaveItem) {
                              List.push({ value: this.state.NewRoute, label: this.state.NewRoute })
                            }
                            this.setState({
                              RouteList: List,
                              Route: isHaveItem ? isHaveItem?.value : this.state.NewRoute,
                              NewRoute: "",
                              NewRouteAdd: false
                            })
                          }}
                          emed_tid="doc_plan_right_route_new_add_btn">
                          <AddIcon color={this.state.NewRoute === "" ? 'grey' : 'primary'} emed_tid="doc_plan_right_route_new_add_icon" />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }} /> :
                <IconButton
                  onClick={() => {
                    this.setState({
                      NewRouteAdd: true
                    })
                  }}
                  emed_tid="doc_plan_right_route_add_btn">
                  <AddIcon color={'primary'} emed_tid="doc_plan_right_route_add_icon" />
                </IconButton>
              }
            </Box>
          </Box>
          <Box emed_tid="doc_plan_right_comments_box">
            <Typography className='eMed_refdoc_title' emed_tid="doc_plan_right_comments_label">{t("Comments")}</Typography>
            <TextField
              emed_tid="doc_plan_right_comments_textfield"
              size='small'
              className='eMed_DocNotes_TextFields'
              multiline={true}
              rows={2}
              label={t("Comments")}
              inputProps={{ maxLength: 100, emed_tid: "doc_plan_right_comments_input" }}
              value={this.state.Comments}
              onChange={(e) => {
                if (CommonValidation.ALPHA_NUM_SPLCHAR(e.target.value) || e.target.value === "") {
                  this.setState({ Comments: e.target.value })
                }
              }}
            />
          </Box>
          <Box emed_tid="doc_plan_right_procedure_box">
            <Typography className='eMed_refdoc_title' emed_tid="doc_plan_right_procedure_label">{t("Procedure")}</Typography>
            <Box className="eMed_DocNotes_FreqChips_Wrapp" emed_tid="doc_plan_right_procedure_autocomplete_box">
              <Autocomplete
                emed_tid="doc_plan_right_procedure_autocomplete"
                size='small'
                sx={{ width: '28vw' }}
                options={this.state.ProcedureList}
                getOptionLabel={(options) => options.value ? options.value : options}
                value={this.state?.Procedure}
                onChange={(e, newValue) => {
                  this.setState({
                    Procedure: newValue
                  })
                }}
                renderOption={(props, option) => {
                  let isLabel = option?.value
                  return (
                    <li {...props} style={{ padding: "0vh 1.5vh" }} emed_tid={`doc_plan_right_procedure_option_${option?.value}`}>
                      <ListItem sx={{ display: 'flex', justifyContent: 'space-between', padding: 0, margin: 0 }} emed_tid={`doc_plan_right_procedure_option_item_${option?.value}`}>
                        <ListItemText primary={isLabel?.length > 23 ? <Tooltip placement='top' title={isLabel} emed_tid={`doc_plan_right_procedure_option_tooltip_${option?.value}`}>{<div emed_tid={`doc_plan_right_procedure_option_text_${option?.value}`}>{isLabel?.slice(0, 23) + '...'}</div>}</Tooltip> : isLabel} emed_tid={`doc_plan_right_procedure_option_text_primary_${option?.value}`} />
                        {option.type === 'procedure' ? <IconButton
                          edge="end"
                          color="error"
                          onClick={(e) => {
                            e.stopPropagation();
                            this.setState({
                              SelectedDeleteChip: option ? option.value : "",
                              DeleteChipType: "procedure",
                              deletePopup: true
                            });
                          }}
                          emed_tid={`doc_plan_right_procedure_option_delete_btn_${option?.value}`}
                        >
                          <Tooltip placement='top' title={"Delete"} arrow emed_tid={`doc_plan_right_procedure_option_delete_tooltip_${option?.value}`}>
                            <DeleteIcon sx={{ height: "2.5vh", width: "2.5vw" }} emed_tid={`doc_plan_right_procedure_option_delete_icon_${option?.value}`} /> </Tooltip>
                        </IconButton>: null}
                      </ListItem>
                    </li> 
                  );
                }}
                renderInput={(params) => <TextField  {...params}
                  emed_tid="doc_plan_right_procedure_textfield"
                  inputProps={{ ...params.inputProps, maxLength: 30, emed_tid: "doc_plan_right_procedure_input" }}
                  autoComplete='off'
                  placeholder="Procedure"
                  onChange={(e) => {
                    if (e.target.value != "") {
                      this.setState({
                        Procedure: e.target.value
                      }, () => { this.getPlanFrequentList(false, {}, e.target.value) })
                    } else {
                      this.setState({ ProcedureList: [] })
                    }
                  }}
                />}
              />
            </Box>
          </Box>
          <Box emed_tid="doc_plan_right_description_box">
            <Typography className='eMed_refdoc_title' emed_tid="doc_plan_right_description_label">{t("Description")}</Typography>
            <TextField
              emed_tid="doc_plan_right_description_textfield"
              size='small'
              className='eMed_DocNotes_TextFields'
              multiline={true}
              rows={2}
              label={t("Description")}
              inputProps={{ maxLength: 100, emed_tid: "doc_plan_right_description_input" }}
              value={this.state.Description}
              onChange={(e) => {
                if (CommonValidation.ALPHA_NUM_SPLCHAR(e.target.value) || e.target.value === "") {
                  this.setState({ Description: e.target.value })
                }
              }}
            />
          </Box>
        </Box>
        <Stack spacing={2} direction="row" sx={{ backgroundColor: Colors.DataTblHeaderbg }} alignItems="center" justifyContent="center" height={"6vh"} emed_tid="doc_plan_right_actions">
          <Button variant='outlined' size="small" _id="eMed_Config_btn" onClick={() => { this.ClearData() }} emed_tid="doc_plan_right_clear_btn">{t("Clear")}</Button>
          <Button disabled={!this.state.InhouseTreatment && !this.state.DosageStrength && !this.state.Route && !this.state.Comments && !this.state.Procedure && !this.state.Description} variant='contained' size="small" id="eMed_Config_btn" onClick={() => {this.PostPlanData() }} emed_tid="doc_plan_right_add_btn">{t("Add")}</Button>
        </Stack>
        {this.state.isErrorMsg ?
          <ToastMsg
            emed_tid="doc_plan_right_error_toast"
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            emed_tid="doc_plan_right_success_toast"
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.deletePopup ? <DeletePopup
          emed_tid="doc_plan_right_delete_popup"
          DeletTitle={`Are you sure ? Do you want to remove ${this.state.SelectedDeleteChip} from suggestion ?`}
          deleteAlertPopupClose={this.popupClose.bind(this)}
          removeData={this.deleteFrequencysugg.bind(this)}
          disable={this.state.removeData}
        /> : null}
      </Box>
    )
  }
}
export default withTranslation()(DocPlanRight)
